import { translate } from 'support/translate';

export type TextStyles = 'light' | 'regular' | 'medium' | 'bold' | 'black';

export const getFontFaceFromStyle = (style: TextStyles) => {
  switch (style) {
    case 'light':
      return 'Roboto-Light';
    case 'regular':
      return 'Roboto';
    case 'medium':
      return 'Roboto-Medium';
    case 'bold':
      return 'Roboto-Bold';
    case 'black':
      return 'Roboto-Black';
  }
};

export const withSeparator = (...text: string[]) => {
  const separator = translate('global.metadataSeparator');
  return text.filter(str => !!str).join(separator);
};

export const extractUrlFromText = (text: string): string => {
  if (!text) return '';

  // Try to extract URL from <a href="..."> tags
  const hrefMatch = text.match(/<a\s+[^>]*href\s*=\s*["']([^"']+)["'][^>]*>/i);
  if (hrefMatch && hrefMatch[1]) {
    return hrefMatch[1];
  }

  // Fallback: extract plain URLs (http:// or https://)
  const urlMatch = text.match(/https?:\/\/[^\s<>"']+/i);
  if (urlMatch && urlMatch[0]) {
    return urlMatch[0];
  }

  return '';
};

export const convertAnchorTagsToBold = (text: string): string => {
  if (!text) return '';

  return text.replace(
    /<a\s+[^>]*href\s*=\s*["'][^"']*["'][^>]*>(.*?)<\/a>/gi,
    '<b>$1</b>',
  );
};
